// extracted by mini-css-extract-plugin
module.exports = {"h1":"heading-tag_h1__13KPC","h2":"heading-tag_h2__3haAi","h3":"heading-tag_h3__3VtQC"};